module.exports = __webpack_public_path__ + "img/hangye5.207cda68.png";